import schema from 'shared/@generated/buyer-profile-schema.json';

export const buyerProfileSchema = schema satisfies Record<string, string[]>;

export type SchemaKey = keyof typeof buyerProfileSchema;

export type BuyerProfile = Record<SchemaKey, string>;
